import { useWidget } from 'components/Widget/useWidget';
import NinjaTable from 'components/tables/NinjaTable';
import { DateFormatter } from 'components/tables/NinjaTable/formatters';
import React, { useMemo } from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import WidgetsCommonColumns from 'components/widgets/components/WidgetsCommonColumns';

const PnLByDaysTable = ({ height, widget_key }) => {
  const { dates } = useWidgetDate(widget_key);
  const { filters } = useWidget();

  const columns = useMemo(
    () => [
      {
        name: 'Date',
        key: 'date',
        width: 120,
        sortable: true,
        renderCell: DateFormatter,
        renderSummaryCell: () => {
          return 'Totals';
        },
      },
      ...WidgetsCommonColumns(),
    ],
    [dates]
  );

  return (
    <NinjaTable
      columns={columns}
      dataProvider='dashboardDailyStats'
      queryParams={{ ...dates, ...filters }}
      cardProps={{ disable: true }}
      maxHeight={height}
      footerProps={{ readOnlyPagination: true }}
      tableProps={{ template: 'widget' }}
    />
  );
};

export default PnLByDaysTable;
